import Filter from "./Filter";
import List from "./List";

export default {
    Filter,
    List
}